export { default } from './MinorButton';
